<template>
  <div class="wechat-applyment-wizard">
	  <div class="base_form base_form_padding  " style="height: calc(100vh - 80px);">
    <div class=" ">
      <div class="wizard-head">
        <div>
          <div class="page-title">{{ pageTitle }}</div>
          <div class="base_tips mt5">{{ pageTips }}</div>
        </div>
        <div class="head-actions">
			<el-button size="small" type="primary" :disabled="draftDisabled" :loading="saving" @click="saveDraft">保存草稿</el-button>
			<el-button v-if="canSubmitApplyment" size="small" type="success" :disabled="submitDisabled" :loading="submitting" @click="submitCurrent">
			  提交审核
			</el-button>
			<el-button size="small" :disabled="syncDisabled" :loading="syncingStatus" @click="syncCurrent">同步状态</el-button>
			<el-button size="small" :disabled="checkDisabled" :loading="checkingReady" @click="checkReady">支付检查</el-button>
          <el-button v-if="isShopMode" size="small" icon="el-icon-back" @click="$router.back()">返回</el-button>
          <el-button v-else size="small" @click="$router.push('/weishop/store/wechat/profile')">查看档案</el-button>
        </div>
      </div>

      <wechat-applyment-status-panel
        class="mt15"
        :applyment="applyment"
        :profile="profile"
        :block-reason="providerMissingText"
        compact
      />

      <div class="applyment-summary mt15" style="display: flex;">
        <!-- <div class="summary-item" style="flex:1">
          <span>申请状态</span>
          <el-tag size="small" :type="profileEnabled ? 'success' : 'primary'">{{ topStatusText }}</el-tag>
        </div> -->
        <div class="summary-item" style="flex:1"><span>申请路径</span>标准特约商户</div>
        <div class="summary-item" style="flex:1"><span>主体类型</span>{{ subjectTypeText }}</div>
        <div class="summary-item" style="flex:1"><span>资料来源</span>系统预填，可修改</div>
        <div class="summary-item" style="flex:1"><span>申请单编号</span>{{ applyment.applyment_id || "提交后生成" }}</div>
        <div class="summary-item" style="flex:1"><span>资料归属</span>{{ currentStoreName }}</div>
        <div class="summary-item" style="flex:1"><span>最后保存</span>{{ applyment.updated_at || profile.updated_at || "未保存" }}</div>
      </div>
    </div>

    <div class="  mt20  " v-loading="loading">
      <el-alert
        v-if="providerMissingText"
        class="mb15"
        type="warning"
        :closable="false"
        :title="providerMissingText"
      />
      <el-alert
        v-if="missingLabels.length"
        class="mb15"
        type="error"
        :closable="false"
      >
		<div slot="title">{{`还有 ${missingLabels.length} 项必填资料未完成：${missingLabels.slice(0, 8).join('、')}${missingLabels.length > 8 ? '等' : ''}`}}
		<el-button size="mini" type="text" style="font-weight: bold;" @click="goFirstMissing">定位第一个缺项模块</el-button></div>
      </el-alert>

      <div class="workspace-layout">
        <div class="module-nav" >
          <div
            v-for="item in modules"
            :key="item.key"
            :class="['module-item', { active: activeModule === item.key }]"
            @click="activeModule = item.key"
          >
            <span>{{ item.title }}</span>
            <el-tag size="mini" :type="moduleStatusType(item.key)">{{ moduleStatusText(item.key) }}</el-tag>
          </div>
        </div>

        <div class="module-form">
          <el-form :model="form" label-width="70px" size="small">
            <section v-show="activeModule === 'contact'" class="form-section">
              <div class="section-title">联系人 / 超级管理员</div>
              <div :class="isHandlerContact ? 'form-two-column' : 'contact-single-column'">
                <div class="form-main set_bg">
                  <div class="form-main-title">1 填写联系信息</div>
                  <el-form-item v-if="isShopMode" label="资料归属">
                    <el-select
                      v-model="form.store_id" style="width: 400px;"
                      filterable
                      placeholder="请选择资料归属"
                      class="field-control"
                      @change="handleStoreChange"
                    >
                      <el-option v-if="!isRegionAccount" :label="platformLabel" :value="0" />
                      <el-option v-for="item in storeList" :key="item.id" :label="item.title" :value="Number(item.id)" />
                    </el-select>
                    <div class="base_tips mt5" style="width: 400px;">仅用于预填资料和权限隔离，不代表当前收款门店；收款请在门店收款配置中选择商户档案。</div>
                  </el-form-item>
                  <el-form-item v-else label="资料归属">
                    <el-input style="width: 400px;" :value="currentStoreName" disabled class="field-control" />
                  </el-form-item>
                  <el-form-item label="超管类型">
                    <el-radio-group v-model="form.contact.contact_type">
                      <el-radio-button label="LEGAL">法人</el-radio-button>
                      <el-radio-button label="SUPER">经办人</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="真实姓名">
                    <el-input style="width: 400px;" v-model="form.contact.contact_name" class="field-control" />
                  </el-form-item>
                  <el-form-item label="联系电话">
                    <el-input style="width: 400px;" v-model="form.contact.mobile_phone" class="field-control" />
                    <div class="base_tips" style="width: 400px;">用于接收微信支付的重要管理信息及日常操作验证码，超管签约时可自助修改手机号，并进行短信验证</div>
                  </el-form-item>
                  <el-form-item label="联系邮箱">
                    <el-input style="width: 400px;" v-model="form.contact.contact_email" class="field-control" />
                  </el-form-item>
                  <template v-if="isHandlerContact">
                    <el-form-item label="证件类型">
                      <el-select style="width: 400px;" v-model="form.contact.contact_id_doc_type" class="field-control">
                        <el-option label="中国大陆居民身份证" value="IDENTIFICATION_TYPE_IDCARD" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="证件号码">
                      <el-input style="width: 400px;" v-model="form.contact.contact_id_number" class="field-control" />
                    </el-form-item>
                    <el-form-item label="证件期效">
                      <el-date-picker
                        v-model="form.contact.contact_period_begin"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="开始日期"
                        class="date-control"
                      />
                      <span class="date-separator">至</span>
                      <el-date-picker
                        v-if="!isContactLongTerm"
                        v-model="form.contact.contact_period_end"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="结束日期"
                        class="date-control"
                      />
                      <el-input v-else value="长期" disabled class="date-control" />
                      <el-checkbox v-model="form.contact.contact_period_long_term" :true-label="1" :false-label="0" class="ml10">
                        长期有效
                      </el-checkbox>
                    </el-form-item>
                  </template>
                </div>
                <div v-if="isHandlerContact" class="material-side">
                  <div class="material-side-title">2 上传经办人证件</div>
                  <div class="material-side-desc">经办人作为超级管理员时，需上传身份证正反面，证件内容应清晰完整。</div>
                  <wechat-material-upload
                    label="上传经办人证件正面"
                    tip="经办人身份证人像面"
                    :value="form.files.contact_id_doc_copy || {}"
                    :recognizing="recognizingType === 'contact_id_doc_copy'"
                    :disabled="loading"
                    @pick="pickFile('contact_id_doc_copy')"
                    @remove="removeFile('contact_id_doc_copy', $event)"
                  />
                  <wechat-material-upload
                    label="上传经办人证件反面"
                    tip="经办人身份证国徽面"
                    :value="form.files.contact_id_doc_copy_back || {}"
                    :recognizing="recognizingType === 'contact_id_doc_copy_back'"
                    :disabled="loading"
                    @pick="pickFile('contact_id_doc_copy_back')"
                    @remove="removeFile('contact_id_doc_copy_back', $event)"
                  />
                </div>
              </div>
            </section>
			
            <section v-show="activeModule === 'subject'" class="form-section">
              <div class="section-title">主体资料</div>
              <div class="form-two-column document-first ">
                <div class="form-main set_bg">
                  <div class="form-main-title">2 核对并补充信息</div>
                  <el-form-item label="进件类型">
                    <el-tag type="primary">标准特约商户</el-tag>
                  </el-form-item>
                  <el-form-item label="主体类型">
                    <el-select style="width:400px" v-model="form.subject.subject_type" class="field-control">
                      <el-option v-for="item in subjectTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="licenseNameLabel">
                    <el-input style="width:400px" v-model="form.subject.merchant_name" class="field-large" />
                  </el-form-item>
                  <el-form-item :label="licenseNumberLabel">
                    <el-input style="width:400px" v-model="form.subject.license_number" class="field-control" />
                  </el-form-item>
                  <el-form-item v-if="requiresCertificateType" label="登记证书类型">
                    <el-select style="width:400px"
                      v-model="form.subject.cert_type"
                      filterable
                      default-first-option
                      placeholder="请选择登记证书类型"
                      class="field-control"
                    >
                      <el-option
                        v-for="item in certificateTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="registeredAddressLabel">
                    <el-input style="width:400px" v-model="form.subject.registered_address" type="text" class="field-large" />
					<div class="base_tips">请依据营业执照/登记证书，填写注册地址 </div>
				  </el-form-item>
                  <el-form-item :label="legalPersonLabel">
                    <el-input style="width:400px" v-model="form.subject.legal_person" class="field-control" />
                  </el-form-item>
                  <el-form-item label="证件类型">
                    <el-input style="width:400px" value="中国大陆居民身份证" disabled class="field-control" />
                  </el-form-item>
                  <el-form-item label="法人姓名">
                    <el-input style="width:400px" v-model="form.subject.id_card_name" class="field-control" />
                  </el-form-item>
                  <el-form-item label="身份证号">
                    <el-input style="width:400px" v-model="form.subject.id_card_number" class="field-control" />
                  </el-form-item>
                  <el-form-item label="证件住址">
                    <el-input style="width:400px" v-model="form.subject.id_card_address" type="text" class="field-large" />
                  </el-form-item>
                  <el-form-item label="证件期效">
                    <el-date-picker
                      v-model="form.subject.card_period_begin"
                      type="date" 
                      value-format="yyyy-MM-dd"
                      placeholder="开始日期"
                      class="date-control"
                    />
                    <span class="date-separator">至</span>
                    <el-date-picker
                      v-if="!isLongTerm"
                      v-model="form.subject.card_period_end"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="结束日期"
                      class="date-control"
                    />
                    <el-input v-else value="长期" disabled class="date-control" />
                    <el-checkbox v-model="form.subject.card_period_long_term" :true-label="1" :false-label="0" class="ml10">
                      长期有效
                    </el-checkbox>
                  </el-form-item>
                </div>
                <div class="material-side">
                  <div class="material-side-title">1 先上传资料</div>
                  <div class="material-side-desc">上传证照后会自动识别并回填右侧字段，识别不准的地方再手动修改。</div>
                  <wechat-material-upload
                    :label="usesBusinessLicense ? '上传彩色营业执照' : '上传登记证书'"
                    :tip="usesBusinessLicense ? '彩色照片或扫描件' : '政府机关、事业单位或其他组织登记证书'"
                    :value="form.files[subjectLicenseFileType] || {}"
                    :recognizing="recognizingType === subjectLicenseFileType"
                    :disabled="loading"
                    @pick="pickFile(subjectLicenseFileType)"
                    @remove="removeFile(subjectLicenseFileType, $event)"
                  />
                  <wechat-material-upload
                    label="上传身份证人像面"
                    tip="法人或经营者身份证正面"
                    :value="form.files.id_card_copy || {}"
                    :recognizing="recognizingType === 'id_card_copy'"
                    :disabled="loading"
                    @pick="pickFile('id_card_copy')"
                    @remove="removeFile('id_card_copy', $event)"
                  />
                  <wechat-material-upload
                    label="上传身份证国徽面"
                    tip="法人或经营者身份证反面"
                    :value="form.files.id_card_national || {}"
                    :recognizing="recognizingType === 'id_card_national'"
                    :disabled="loading"
                    @pick="pickFile('id_card_national')"
                    @remove="removeFile('id_card_national', $event)"
                  />
                </div>
              </div>
            </section>

            <section v-show="activeModule === 'business'" class="form-section">
              <div class="section-title">经营资料</div>
              <div class="form-two-column ">
                <div class="form-main ">
					<div class="set_bg">
                  <div class="form-main-title">1 选择场景并填写信息</div>
                  <el-form-item label="商户简称">
                    <el-input style="width:400px" v-model="form.business.merchant_shortname" class="field-control" />
					<div class="base_tips" style="width:400px">1、在支付完成页向买家展示，需与微信经营类目相关。</div>
					<div class="base_tips" style="width:400px">2、简称要求：① 不支持单纯以人名来命名，若为个体户经营，可用“个体户+经营者名称”或“经营者名称+业务”命名，如“个体户张三”或“张三餐饮店”；② 不支持无实际意义的文案，如“XX特约商户”、“800”、“XX客服电话XXX”；</div>
                  </el-form-item>
                  <el-form-item label="客服电话">
                    <el-input style="width:400px" v-model="form.business.service_phone" class="field-control" />
					<div class="base_tips" style="width:400px">1、请填写真实有效的客服电话，将在交易记录中向买家展示，提供咨询服务</div>
					<div class="base_tips" style="width:400px">2、请确保电话畅通，以便入驻后平台回拨确认。</div>
				  </el-form-item>
                  <el-form-item label="经营场景">
                    <el-checkbox-group v-model="form.business.sales_scenes_type">
                      <el-checkbox v-for="item in salesSceneOptions" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                    </el-checkbox-group>
					<div class="base_tips" style="width:400px">请勾选实际售卖商品/提供服务场景（至少一项），以便为你开通需要的支付权限，
建议只勾选目前必须的场景，以便尽快通过入驻审核，其他支付权限你可在入驻后再根据实际需要发起申请</div>
                  </el-form-item>
                  <el-form-item v-if="sceneSelected('SALES_SCENES_MINI_PROGRAM')" label="渠道PID">
                    <el-input style="width:400px"
                      v-model.trim="form.business.mini_program_sub_appid"
                      clearable
                      placeholder="请输入小程序 APPID"
                      class="field-control"
                    />
                    <div class="base_tips mt5">默认使用店铺小程序APPID，可按微信申请资料修改。</div>
                  </el-form-item>
                  <template v-if="sceneSelected('SALES_SCENES_STORE')">
                    <el-form-item label="门店名称">
                      <el-input style="width:400px" v-model="form.business.store_name" class="field-large" />
                    </el-form-item>
                    <el-form-item label="经营地区">
                      <el-select style="width:400px"
                        v-model="form.business.address_code"
                        filterable
                        default-first-option
                        placeholder="请选择经营地区"
                        no-data-text="暂无可选项，请联系平台维护字典"
                        class="field-control"
                      >
                        <el-option
                          v-for="item in businessRegionOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="经营地址">
                      <el-input style="width:400px" v-model="form.business.address" type="text"  class="field-large" />
                    </el-form-item>
                  </template>
                  <template v-if="sceneSelected('SALES_SCENES_MP')">
                    <el-form-item label="公众号 APPID">
                      <el-input style="width:400px" v-model="form.business.mp_appid" class="field-control" />
                    </el-form-item>
                  </template>
                  <template v-if="sceneSelected('SALES_SCENES_APP')">
                    <el-form-item label="App APPID">
                      <el-input style="width:400px" v-model="form.business.app_appid" class="field-control" />
                    </el-form-item>
                  </template>
                  <template v-if="sceneSelected('SALES_SCENES_WEB')">
                    <el-form-item label="网站域名">
                      <el-input style="width:400px" v-model="form.business.domain" class="field-control" />
                    </el-form-item>
                    <el-form-item label="网站 APPID">
                      <el-input style="width:400px" v-model="form.business.web_appid" class="field-control" />
                    </el-form-item>
                  </template>
                  <template v-if="weworkSceneSelected">
                    <el-form-item label="企业微信 CorpID">
                      <el-input style="width:400px" v-model="form.business.sub_corp_id" class="field-control" />
                    </el-form-item>
                  </template>
				  </div>
                </div>
                <div class="material-side">
                  <div class="material-side-title">2 上传场景资料</div>
                  <div class="material-side-desc">左侧选择经营场景后，这里只显示微信要求的对应资料。</div>
                  <wechat-material-upload
                    v-if="sceneSelected('SALES_SCENES_MINI_PROGRAM')"
                    label="上传小程序截图"
                    tip="用于辅助证明小程序经营场景，最多 5 张"
                    :value="form.files.mini_program_pics || []"
                    :multiple="isMultipleFileType('mini_program_pics')"
                    :max="fileTypeLimit('mini_program_pics')"
                    :disabled="loading"
                    @pick="pickFile('mini_program_pics')"
                    @remove="removeFile('mini_program_pics', $event)"
                  />
                  <wechat-material-upload
                    v-if="sceneSelected('SALES_SCENES_STORE')"
                    label="上传门头照"
                    tip="门店入口照片"
                    :value="form.files.store_entrance_pic || {}"
                    :disabled="loading"
                    @pick="pickFile('store_entrance_pic')"
                    @remove="removeFile('store_entrance_pic', $event)"
                  />
                  <wechat-material-upload
                    v-if="sceneSelected('SALES_SCENES_STORE')"
                    label="上传店内照"
                    tip="经营场所内部照片"
                    :value="form.files.indoor_pic || {}"
                    :disabled="loading"
                    @pick="pickFile('indoor_pic')"
                    @remove="removeFile('indoor_pic', $event)"
                  />
                  <wechat-material-upload
                    v-if="sceneSelected('SALES_SCENES_MP')"
                    label="上传公众号页面截图"
                    tip="用于辅助证明公众号经营场景，最多 5 张"
                    :value="form.files.mp_pics || []"
                    :multiple="isMultipleFileType('mp_pics')"
                    :max="fileTypeLimit('mp_pics')"
                    :disabled="loading"
                    @pick="pickFile('mp_pics')"
                    @remove="removeFile('mp_pics', $event)"
                  />
                  <wechat-material-upload
                    v-if="sceneSelected('SALES_SCENES_APP')"
                    label="上传 App 页面截图"
                    tip="用于辅助证明 App 经营场景，最多 5 张"
                    :value="form.files.app_pics || []"
                    :multiple="isMultipleFileType('app_pics')"
                    :max="fileTypeLimit('app_pics')"
                    :disabled="loading"
                    @pick="pickFile('app_pics')"
                    @remove="removeFile('app_pics', $event)"
                  />
                  <wechat-material-upload
                    v-if="sceneSelected('SALES_SCENES_WEB')"
                    label="上传网站授权函"
                    :value="form.files.web_authorisation || {}"
                    :disabled="loading"
                    @pick="pickFile('web_authorisation')"
                    @remove="removeFile('web_authorisation', $event)"
                  />
                  <wechat-material-upload
                    v-if="weworkSceneSelected"
                    label="上传企业微信页面截图"
                    tip="用于辅助证明企业微信经营场景，最多 5 张"
                    :value="form.files.wework_pics || []"
                    :multiple="isMultipleFileType('wework_pics')"
                    :max="fileTypeLimit('wework_pics')"
                    :disabled="loading"
                    @pick="pickFile('wework_pics')"
                    @remove="removeFile('wework_pics', $event)"
                  />
                </div>
              </div>
            </section>

            <section v-show="activeModule === 'settlement'" class="form-section">
              <div class="section-title">行业资质 / 结算规则</div>
              <div class="form-two-column">
                <div class="form-main">
					<div class="set_bg" style="display: block;">
                  <div class="form-main-title">1 选择行业和结算规则</div>
                  <el-form-item label="所属行业">
                    <el-select style="width:400px"
                      v-model="form.settlement.qualification_type"
                      filterable
                      default-first-option
                      placeholder="请选择所属行业"
                      no-data-text="暂无可选项，请确认主体类型或联系平台维护字典"
                      class="field-control"
                      @change="handleQualificationChange"
                    >
                      <el-option
                        v-for="item in qualificationOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
					<div class="base_tips">请填写商家的所属行业、特殊资质等信息</div>
                  </el-form-item>
                  <el-form-item label="结算规则">
                    <el-select style="width:400px"
                      v-model="form.settlement.settlement_id"
                      filterable
                      default-first-option
                      placeholder="请选择结算规则"
                      no-data-text="暂无可选项，请确认主体类型或联系平台维护字典"
                      class="field-control"
                      @change="handleSettlementChange"
                    >
                      <el-option
                        v-for="item in settlementOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="结算费率">
                    <el-input style="width:400px" :value="settlementRateText" disabled class="field-control" />
                  </el-form-item>
				  </div>
                </div>
                <div class="material-side">
                  <div class="material-side-title">
                    2 上传行业资质
                    <span v-if="currentQualificationRequiresMaterial" class="field-required">*</span>
                  </div>
                  <div class="material-side-desc">{{ qualificationMaterialTip }}</div>
                  <wechat-material-upload
                    label="上传行业资质"
                    tip="如行业要求特殊资质，请在此上传"
                    :value="form.files.qualifications || []"
                    :multiple="isMultipleFileType('qualifications')"
                    :max="fileTypeLimit('qualifications')"
                    :disabled="loading"
                    @pick="pickFile('qualifications')"
                    @remove="removeFile('qualifications', $event)"
                  />
                </div>
              </div>
            </section>

            <section v-show="activeModule === 'bank_account'" class="form-section">
              <div class="section-title">结算账户</div>
              <div class="form-two-column document-first">
                <div class="form-main">
					<div class="set_bg">
                  <div class="form-main-title">2 核对并补充账户信息</div>
                  <el-form-item label="账户类型">
                    <el-select style="width:400px" v-model="form.bank_account.bank_account_type" class="field-control" @change="handleBankAccountTypeChange">
                      <el-option v-for="item in bankAccountTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="开户名称">
                    <el-input style="width:400px" v-model="form.bank_account.account_name" class="field-control" />
                  </el-form-item>
                  <el-form-item label="开户银行">
                    <el-select style="width:400px"
                      v-model="bankSelectKey"
                      filterable
                      remote
                      reserve-keyword
                      default-first-option
                      placeholder="请输入银行名称搜索"
                      :loading="bankLoading"
                      :remote-method="searchWechatBanks"
                      no-data-text="请输入银行名称搜索，找不到时选择“其他银行”并填写支行信息"
                      class="field-control"
                      @change="handleBankChange"
                    >
                      <el-option
                        v-for="(item, index) in commonBanks"
                        :key="bankOptionKey(item, index)"
                        :label="item.label"
                        :value="bankOptionKey(item, index)"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="开户地区">
                    <div class="inline-controls field-control">
                      <el-select 
                        v-model="form.bank_account.bank_province_code"
                        filterable
                        default-first-option
                        placeholder="请选择省份"
                        :loading="bankProvinceLoading"
                        @change="handleBankProvinceChange"
                      >
                        <el-option v-for="item in bankProvinceOptions" :key="item.value" :label="item.label" :value="item.value" />
                      </el-select>
                      <el-select
                        v-model="form.bank_account.bank_address_code"
                        filterable
                        default-first-option
                        placeholder="请选择城市"
                        :loading="bankCityLoading"
                        :disabled="!form.bank_account.bank_province_code"
                        @change="handleBankCityChange"
                      >
                        <el-option v-for="item in bankCityOptions" :key="item.value" :label="item.label" :value="item.value" />
                      </el-select>
                    </div>
                    <div class="base_tips mt5">用于按微信银行组件查询支行；提交时仍按微信进件字段传入城市编码。</div>
                  </el-form-item>
                  <el-form-item v-if="currentBankNeedBranch" label="开户支行">
                    <el-select style="width:400px"
                      v-model="form.bank_account.bank_branch_id"
                      filterable
                      remote
                      reserve-keyword
                      default-first-option
                      placeholder="请输入支行名称搜索"
                      :loading="bankBranchLoading"
                      :disabled="!canQueryBankBranch"
                      :remote-method="searchBankBranches"
                      no-data-text="暂无可选支行，请先选择开户银行和城市"
                      class="field-control"
                      @change="handleBankBranchChange"
                    >
                      <el-option
                        v-for="item in bankBranchOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                    <div v-if="!canQueryBankBranch" class="base_tips mt5">
                      请先选择需要支行的开户银行和开户城市。
                    </div>
                    <div v-else-if="!hasBankBranchDictionary" class="base_tips mt5">
                      暂无可选支行，可换城市重试或联系平台维护微信银行字典。
                    </div>
                    <div v-else-if="hasSavedBranchNameOnly" class="base_tips mt5">
                      已保存的开户支行：{{ form.bank_account.bank_branch_name }}。请从上方选择器重新选择开户支行。
                    </div>
                  </el-form-item>
                  <el-form-item v-else label="开户支行">
                    <el-input style="width:400px" value="该开户银行无需填写支行" disabled class="field-control" />
                  </el-form-item>
                  <el-form-item label="银行账号">
                    <el-input style="width:400px" v-model="form.bank_account.account_number" class="field-control" />
					<div class="base_tips">请务必填写公司的对公银行账户</div>
                  </el-form-item></div>
                </div>
                <div class="material-side">
                  <div class="material-side-title">可选：上传开户资料</div>
                  <div class="material-side-desc">有银行卡或开户证明时可上传辅助核对，未上传不影响提交。</div>
                  <wechat-material-upload
                    label="上传银行卡或开户资料"
                    :value="form.files.bank_card_copy || {}"
                    :recognizing="recognizingType === 'bank_card_copy'"
                    :disabled="loading"
                    @pick="pickFile('bank_card_copy')"
                    @remove="removeFile('bank_card_copy', $event)"
                  />
                </div>
              </div>
            </section>

            <section v-show="activeModule === 'addition'" class="form-section">
              <div class="section-title">补充材料</div>
              <div class="form-two-column">
                <div class="form-main set_bg">
                  <div class="form-main-title">1 填写补充说明</div>
                  <el-form-item label="资金来源">
                    <el-select
                      v-model="fundSourceSelections"
                      multiple
                      collapse-tags
                      clearable
                      placeholder="请选择资金来源"
                      class="field-large"
                    >
                      <el-option
                        v-for="item in fundSourceOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                    <div class="base_tips mt5">微信要求补充资金来源时选择，可多选。</div>
                  </el-form-item>
                  <el-form-item label="资金用途">
                    <el-select
                      v-model="fundUseSelections"
                      multiple
                      collapse-tags
                      clearable
                      placeholder="请选择资金用途"
                      class="field-large"
                    >
                      <el-option
                        v-for="item in fundUseOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                    <div class="base_tips mt5">微信要求补充资金用途时选择，可多选。</div>
                  </el-form-item>
                  <el-form-item label="补充说明">
                    <el-input style="width:400px"
                      v-model="form.addition_info.description"
                      type="textarea"
                      :rows="4"
                      maxlength="512"
                      show-word-limit
                      placeholder="如有需要，可填写补充说明"
                      class="field-large"
                    />
                  </el-form-item>
				  <el-form-item label="商户确认">
				    <div v-if="!canShowConfirmCode" class="base_tips">
				      {{ applyment.reject_reason || "提交审核后，等待微信返回商户确认信息。" }}
				    </div>
				    <div v-else class="confirm-box">
				      <img v-if="confirmQr" :src="confirmQr" style="margin-bottom: 10px;" class="confirm-qr" alt="商户确认二维码" />
				      <div v-if="confirmQr" style="margin-bottom: 20px;" class="base_tips">正在加急处理中，请您耐心等待，预计1-3个工作日内微信支付将会完成审核，高峰时期可能会超出预计时间，感谢您的理解
请指引超级管理员使用微信扫以下二维码（30天有效，过期后将生成新二维码），完成核对联系信息后，可接收申请单进展通知</div>
					  <el-input style="width:400px" ref="confirmInput" :value="confirmUrl" readonly class="field-large">
				        <el-button slot="append" @click="copyConfirmUrl">复制</el-button>
				      </el-input>
				      <div class="base_tips mt10">请商户负责人使用微信扫码完成确认。确认完成后点击同步状态。</div>
				    </div>
				    <el-button class="mt10" size="small" :disabled="syncConfirmDisabled" :loading="confirmSyncing" @click="syncConfirmStatus">
				      同步确认状态
				    </el-button>
				  </el-form-item>
                </div>
                <div class="material-side">
                  <div class="material-side-title">2 上传补充材料</div>
                  <div class="material-side-desc">只有微信要求补充时再上传，日常新增商户可以留空。</div>
                  <wechat-material-upload
                    label="上传补充材料"
                    tip="可选，用于补充说明特殊经营情况"
                    :value="form.files.business_addition_pics || []"
                    :multiple="isMultipleFileType('business_addition_pics')"
                    :max="fileTypeLimit('business_addition_pics')"
                    :disabled="loading"
                    @pick="pickFile('business_addition_pics')"
                    @remove="removeFile('business_addition_pics', $event)"
                  />
                </div>
              </div>
              
            </section>
          </el-form>
        </div>
      </div>
    </div>
    </div>

    <!-- <div class="base_fixed_bottom">
      <el-button size="small" type="primary" :disabled="draftDisabled" :loading="saving" @click="saveDraft">保存草稿</el-button>
      <el-button v-if="canSubmitApplyment" size="small" type="success" :disabled="submitDisabled" :loading="submitting" @click="submitCurrent">
        提交审核
      </el-button>
      <el-button size="small" :disabled="syncDisabled" :loading="syncingStatus" @click="syncCurrent">同步状态</el-button>
      <el-button size="small" :disabled="checkDisabled" :loading="checkingReady" @click="checkReady">支付检查</el-button>
    </div> -->

    <xsk-manage
      :managehide.sync="imagePicker.show"
      @confirm="onAssetPicked"
      :multiple="imagePicker.multiple"
      :count="imagePicker.count"
      is_rest
    />
  </div>
</template>

<script>
import QR from "@/components/common/wxqrcode.js";
import { eltips } from "@/util/util.js";
import {
  checkProfileReadiness,
  checkStoreProfileReadiness,
  getApplyment,
  getApplymentBankBranches,
  getApplymentBankCities,
  getApplymentBankProvinces,
  getApplymentBanks,
  getApplymentDictionaries,
  getApplymentPrefill,
  getStoreApplyment,
  getStoreApplymentBankBranches,
  getStoreApplymentBankCities,
  getStoreApplymentBankProvinces,
  getStoreApplymentBanks,
  getStoreApplymentPrefill,
  recognizeApplymentFile,
  recognizeStoreApplymentFile,
  saveApplyment,
  saveStoreApplyment,
  submitApplyment,
  submitStoreApplyment,
  syncApplyment,
  syncApplymentConfirm,
  syncStoreApplyment,
  syncStoreApplymentConfirm,
} from "@/api/weishop/wechatApplyment";
import {
  applymentStatusValue,
  canCheckApplymentReadiness,
  canSaveApplymentDraft,
  canShowApplymentConfirmCode,
  canSubmitApplyment,
  canSyncApplymentConfirm,
  canSyncApplymentStatus,
  confirmQrForUrl,
  confirmUrlForApplyment,
  emptyForm,
  mergePrefill,
  MODULES,
  STORE_PLATFORM_LABEL,
  statusText,
  storeName,
} from "../utils/wechatApplymentForm";
import WechatApplymentStatusPanel from "./WechatApplymentStatusPanel.vue";
import WechatMaterialUpload from "./WechatMaterialUpload.vue";
import {
  isRegionScope,
  resolveWeiShopApi,
} from "@/views/apps/weishop/region/utils/regionApiMap";

const clone = (value) => JSON.parse(JSON.stringify(value || {}));

const SUBJECT_TYPES = [
  { label: "个体工商户", value: "SUBJECT_TYPE_INDIVIDUAL" },
  { label: "企业", value: "SUBJECT_TYPE_ENTERPRISE" },
  { label: "政府机关", value: "SUBJECT_TYPE_GOVERNMENT" },
  { label: "事业单位", value: "SUBJECT_TYPE_INSTITUTIONS" },
  { label: "其他组织", value: "SUBJECT_TYPE_OTHERS" },
];

const SALES_SCENES = [
  { label: "线下场所", value: "SALES_SCENES_STORE" },
  { label: "公众号", value: "SALES_SCENES_MP" },
  { label: "小程序", value: "SALES_SCENES_MINI_PROGRAM" },
  // { label: "App", value: "SALES_SCENES_APP" },
  // { label: "互联网网站", value: "SALES_SCENES_WEB" },
  // { label: "企业微信", value: "SALES_SCENES_WEWORK" },
];

const CERTIFICATE_TYPES = [
  { label: "事业单位法人证书", value: "CERTIFICATE_TYPE_2388" },
  { label: "统一社会信用代码证书", value: "CERTIFICATE_TYPE_2389" },
  { label: "有偿服务许可证（军队医院适用）", value: "CERTIFICATE_TYPE_2390" },
  { label: "医疗机构执业许可证（军队医院适用）", value: "CERTIFICATE_TYPE_2391" },
  { label: "企业营业执照（挂靠企业的党组织适用）", value: "CERTIFICATE_TYPE_2392" },
  { label: "组织机构代码证（政府机关适用）", value: "CERTIFICATE_TYPE_2393" },
  { label: "社会团体法人登记证书", value: "CERTIFICATE_TYPE_2394" },
  { label: "民办非企业单位登记证书", value: "CERTIFICATE_TYPE_2395" },
  { label: "基金会法人登记证书", value: "CERTIFICATE_TYPE_2396" },
  { label: "慈善组织公开募捐资格证书", value: "CERTIFICATE_TYPE_2397" },
  { label: "农民专业合作社法人营业执照", value: "CERTIFICATE_TYPE_2398" },
  { label: "宗教活动场所登记证", value: "CERTIFICATE_TYPE_2399" },
  { label: "其他证书/批文/证明", value: "CERTIFICATE_TYPE_2400" },
];

const DEFAULT_FILE_RULES = [
  { type: "business_license_copy", label: "营业执照" },
  { type: "certificate_copy", label: "登记证书" },
  { type: "id_card_copy", label: "身份证人像面" },
  { type: "id_card_national", label: "身份证国徽面" },
  { type: "contact_id_doc_copy", label: "经办人证件正面" },
  { type: "contact_id_doc_copy_back", label: "经办人证件反面" },
  { type: "store_entrance_pic", label: "门头照" },
  { type: "indoor_pic", label: "店内照" },
  { type: "mini_program_pics", label: "小程序截图" },
  { type: "mp_pics", label: "公众号资料" },
  { type: "app_pics", label: "App 资料" },
  { type: "web_authorisation", label: "网站授权函" },
  { type: "wework_pics", label: "企业微信资料" },
  { type: "qualifications", label: "行业资质" },
  { type: "bank_card_copy", label: "银行卡 / 开户资料" },
];

const STORE_FALLBACK_DICTIONARIES = {
  subject_types: SUBJECT_TYPES,
  sales_scenes: SALES_SCENES,
  bank_account_types: [
    { label: "对公银行账户", value: "BANK_ACCOUNT_TYPE_CORPORATE" },
    { label: "经营者个人银行卡", value: "BANK_ACCOUNT_TYPE_PERSONAL" },
  ],
  file_rules: DEFAULT_FILE_RULES,
  file_labels: DEFAULT_FILE_RULES.reduce((result, item) => {
    result[item.type] = item.label;
    return result;
  }, {}),
  default_settlement: {
    settlement_id: "",
    industry_id: "",
    qualification_type: "",
  },
};

const STORE_DICTIONARY_KEYS = [
  "subject_types",
  "sales_scenes",
  "bank_account_types",
  "file_rules",
  "file_labels",
  "default_settlement",
  "settlement_rules",
  "qualification_types",
  "certificate_types",
  "cert_types",
  "regions",
];

const FILE_TYPE_ALIASES = {
  web_authorization_letter: "web_authorisation",
  enterprise_wechat_pics: "wework_pics",
};

const RECOGNIZABLE_FILE_TYPES = [
  "business_license_copy",
  "certificate_copy",
  "id_card_copy",
  "id_card_national",
  "contact_id_doc_copy",
  "contact_id_doc_copy_back",
  "bank_card_copy",
];

const MULTIPLE_FILE_LIMITS = {
  mini_program_pics: 5,
  mp_pics: 5,
  app_pics: 5,
  wework_pics: 5,
  qualifications: 5,
  business_addition_pics: 5,
};

const FUND_SOURCE_OPTIONS = [
  "经营性收入",
  "自有资金",
  "政府拨款或扶持资金",
  "投资收益与利得",
  "信贷",
  "资产性收入",
];

const FUND_USE_OPTIONS = [
  "经营活动开支",
  "工资薪酬与福利发放",
  "缴纳税费",
  "付款给业务伙伴",
  "支付佣金费用或手续费",
  "债务偿还",
  "账户留存资金，用于用户投诉解决及退款",
];

const isPlainObject = (value) =>
  Object.prototype.toString.call(value) === "[object Object]";

const isEmptyValue = (value) =>
  value === undefined ||
  value === null ||
  value === "" ||
  (Array.isArray(value) && value.length === 0) ||
  (isPlainObject(value) && Object.keys(value).length === 0);

const hasMaterialValue = (material = {}) =>
  !!(material.asset_id || material.url || material.file_id || material.media_id);

const materialKey = (material = {}) => {
  if (material.asset_id) return `asset:${material.asset_id}`;
  if (material.media_id) return `media:${material.media_id}`;
  if (material.url) return `url:${material.url}`;
  if (material.file_id) return `file:${material.file_id}`;
  return "";
};

const asMaterialList = (value) => {
  if (Array.isArray(value)) {
    return value.filter((item) => {
      if (typeof item === "string") return item !== "";
      return isPlainObject(item) && hasMaterialValue(item);
    }).map((item) => (typeof item === "string" ? { media_id: item } : item));
  }

  if (typeof value === "string") return value ? [{ media_id: value }] : [];
  if (isPlainObject(value) && hasMaterialValue(value)) return [value];
  return [];
};

const normalizeAssetMaterial = (asset = {}, current = {}) => ({
  ...current,
  asset_id: asset.id || current.asset_id || "",
  url: asset.qiniu_url || asset.url || asset.file_path || current.url || "",
  name: asset.name || asset.file_name || asset.title || current.name || "",
  media_id: current.media_id || "",
  recognized_at: current.recognized_at || "",
  recognize_status: current.recognize_status || "uploaded",
});

const normalizeServerMaterial = (file = {}, current = {}) => ({
  ...current,
  asset_id: file.asset_id || current.asset_id || "",
  url: file.url || file.qiniu_url || current.url || "",
  name: file.name || file.file_name || current.name || "",
  media_id: file.media_id || current.media_id || "",
  recognized_at: file.recognized_at || current.recognized_at || "",
  recognize_status: file.recognize_status || current.recognize_status || "",
});

const upsertMaterialList = (list, material, limit) => {
  if (!hasMaterialValue(material)) return list.slice(0, limit);
  const key = materialKey(material);
  const next = list.filter((item) => !key || materialKey(item) !== key);
  next.push(material);
  return next.slice(0, limit);
};

const normalizeOptions = (source, fallback = []) => {
  const value = source || fallback;
  if (Array.isArray(value)) {
    return value
      .map((item) => {
        if (typeof item === "string") return { label: item, value: item };
        return {
          ...item,
          label: item.label || item.name || item.title || item.text || item.value || item.code || item.id || "",
          value: item.value || item.code || item.id || item.name || item.label || "",
          rate: item.rate || item.fee_rate || item.settlement_rate || "",
        };
      })
      .filter((item) => item.value);
  }

  return Object.keys(value || {}).map((key) => ({
    label: value[key],
    value: key,
  }));
};

const mergeOptions = (source, fallback = []) => {
  const merged = normalizeOptions(source, []);
  normalizeOptions(fallback, []).forEach((item) => {
    if (!merged.some((option) => option.value === item.value)) merged.push(item);
  });
  return merged;
};

const withCurrentOption = (options, value, label) => {
  if (isEmptyValue(value) || options.some((item) => String(item.value) === String(value))) return options;
  return [{ label, value }].concat(options);
};

const optionItems = (options) => options.map((item) => ({ label: item, value: item }));

const selectedOfficialOptions = (message, options) => {
  const text = String(message || "");
  return options.filter((item) => text.indexOf(item) !== -1);
};

const buildFundsAdditionMessage = (sources, uses) => {
  const parts = [];
  if (sources.length) parts.push(`【资金来源：${sources.join("；")}】`);
  if (uses.length) parts.push(`【资金用途：${uses.join("；")}】`);
  return parts.join("");
};

const SUPPLEMENT_STATUS_VALUES = [
  "60",
  "REJECTED",
  "REJECT",
  "FAILED",
  "FAIL",
  "ERROR",
  "APPLYMENT_STATE_REJECTED",
  "APPLYMENT_STATE_CANCELED",
  "MATERIAL_STATE_REJECTED",
  "MATERIAL_STATE_NEED_SUPPLEMENT",
  "NEED_SUPPLEMENT",
  "SUPPLEMENT_REQUIRED",
];

const TRUTHY_VALUES = ["1", "TRUE", "YES", "Y", "REQUIRED", "NEED", "NEED_SUPPLEMENT", "SUPPLEMENT_REQUIRED"];

const hasMeaningfulValue = (value) => {
  if (isEmptyValue(value)) return false;
  if (Array.isArray(value)) return value.some((item) => hasMeaningfulValue(item));
  if (isPlainObject(value)) return Object.keys(value).some((key) => hasMeaningfulValue(value[key]));
  return true;
};

const ocrFieldsFromResponse = (data = {}) => {
  const raw = data.raw || {};
  const candidates = [
    data.recognized,
    data.fields,
    data.result,
    data.ocr,
    raw.respond,
    raw.data && raw.data.respond,
    raw.data,
    data.respond,
    data,
  ];

  return candidates.find((item) => isPlainObject(item) && hasMeaningfulValue(item)) || {};
};

const normalizeOcrDate = (value) => {
  if (value === undefined || value === null) return "";
  const text = String(value).trim();
  if (!text || text === "长期") return text;

  let matches = text.match(/^(\d{4})(\d{2})(\d{2})$/);
  if (matches) return `${matches[1]}-${matches[2]}-${matches[3]}`;

  matches = text.match(/^(\d{4})[./-](\d{1,2})[./-](\d{1,2})$/);
  if (matches) {
    return `${matches[1]}-${String(matches[2]).padStart(2, "0")}-${String(matches[3]).padStart(2, "0")}`;
  }

  matches = text.match(/(\d{4})年(\d{1,2})月(\d{1,2})日?/);
  if (matches) {
    return `${matches[1]}-${String(matches[2]).padStart(2, "0")}-${String(matches[3]).padStart(2, "0")}`;
  }

  return text;
};

const splitOcrValidPeriod = (value) => {
  const text = value === undefined || value === null ? "" : String(value).trim();
  if (!text) return { begin: "", end: "" };
  const dates = text.match(/\d{8}|\d{4}[./-]\d{1,2}[./-]\d{1,2}|\d{4}年\d{1,2}月\d{1,2}日?/g) || [];

  if (dates.length >= 2) {
    return {
      begin: normalizeOcrDate(dates[0]),
      end: normalizeOcrDate(dates[1]),
    };
  }

  if (dates.length === 1 && text.indexOf("长期") !== -1) {
    return {
      begin: normalizeOcrDate(dates[0]),
      end: "长期",
    };
  }

  return { begin: "", end: "" };
};

const truthyFlag = (value) => {
  if (value === true || value === 1) return true;
  if (typeof value !== "string") return false;
  return TRUTHY_VALUES.indexOf(value.trim().toUpperCase()) !== -1;
};

const statusNeedsSupplement = (value) => {
  if (value === undefined || value === null || value === "") return false;
  return SUPPLEMENT_STATUS_VALUES.indexOf(String(value).trim().toUpperCase()) !== -1;
};

const hasSupplementStatus = (source, keys) =>
  keys.some((key) => statusNeedsSupplement(source[key]));

export default {
  name: "WechatApplymentWizard",
  components: {
    WechatApplymentStatusPanel,
    WechatMaterialUpload,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
    id: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      saving: false,
      submitting: false,
      syncingStatus: false,
      confirmSyncing: false,
      checkingReady: false,
      activeModule: "contact",
      form: emptyForm(),
      prefill: {},
      dictionaries: {},
      applyment: {},
      profile: {},
      responseFormData: {},
      files: [],
      storeList: [],
      storeMap: { 0: STORE_PLATFORM_LABEL },
      bankSelectKey: "",
      bankSearchKeyword: "",
      bankBranchSearchKeyword: "",
      bankLoading: false,
      bankProvinceLoading: false,
      bankCityLoading: false,
      bankBranchLoading: false,
      bankOptions: [],
      bankProvinceOptions: [],
      bankCityOptions: [],
      bankBranchList: [],
      imagePicker: {
        show: false,
        fileType: "",
        multiple: false,
        count: 1,
      },
      recognizingType: "",
    };
  },
  computed: {
    modules() {
      return MODULES;
    },
    isShopMode() {
      return this.mode === "shop";
    },
    isStoreMode() {
      return this.mode === "store";
    },
    isRegionAccount() {
      return isRegionScope();
    },
    applymentListPath() {
      return this.isRegionAccount ? "/region/store/wechat/applyment" : "/weishop/merchants/setting/wechat/applyment";
    },
    isCreateMode() {
      return this.isShopMode && !this.id && !(this.applyment && this.applyment.id);
    },
    pageTitle() {
      return this.isStoreMode ? "微信收款商户资料工作台" : "新增微信收款商户";
    },
    pageTips() {
      return this.isStoreMode
        ? "维护本门店微信收款商户资料，开通后可用于微信服务商分账支付。"
        : "按运营资料收集顺序维护微信收款商户资料，保存草稿后提交审核。";
    },
    platformLabel() {
      return STORE_PLATFORM_LABEL;
    },
    currentStoreName() {
      return storeName(this.form.store_id, this.storeMap);
    },
    fundSourceOptions() {
      return optionItems(FUND_SOURCE_OPTIONS);
    },
    fundUseOptions() {
      return optionItems(FUND_USE_OPTIONS);
    },
    fundSourceSelections: {
      get() {
        return selectedOfficialOptions(this.form.addition_info.description, FUND_SOURCE_OPTIONS);
      },
      set(value) {
        this.updateFundsAdditionMessage(value, this.fundUseSelections);
      },
    },
    fundUseSelections: {
      get() {
        return selectedOfficialOptions(this.form.addition_info.description, FUND_USE_OPTIONS);
      },
      set(value) {
        this.updateFundsAdditionMessage(this.fundSourceSelections, value);
      },
    },
    profileEnabled() {
      return Number(this.profile.is_enabled) === 1;
    },
    topStatusText() {
      return statusText({
        status: this.applyment.status || this.profile.applyment_status,
        is_enabled: this.profile.is_enabled,
      });
    },
    subjectTypeOptions() {
      return mergeOptions(this.dictionaries.subject_types, SUBJECT_TYPES);
    },
    salesSceneOptions() {
      return mergeOptions(this.dictionaries.sales_scenes || this.dictionaries.sales_scenes_type, SALES_SCENES);
    },
    certificateTypeOptions() {
      return mergeOptions(this.dictionaries.certificate_types || this.dictionaries.cert_types, CERTIFICATE_TYPES);
    },
    bankAccountTypeOptions() {
      return normalizeOptions(this.dictionaries.bank_account_types, STORE_FALLBACK_DICTIONARIES.bank_account_types);
    },
    commonBanks() {
      return withCurrentOption(
        this.bankOptions,
        this.form.bank_account.account_bank,
        this.form.bank_account.bank_name || "已保存的开户银行"
      );
    },
    availableSettlementRules() {
      const options = normalizeOptions(this.dictionaries.settlement_rules || this.dictionaries.settlements, []);
      return options.filter((item) => this.optionMatchesSubject(item));
    },
    settlementOptions() {
      const options = this.availableSettlementRules;
      return withCurrentOption(
        options,
        this.form.settlement.settlement_id,
        "已保存的结算规则"
      );
    },
    availableQualificationTypes() {
      const options = normalizeOptions(this.dictionaries.qualification_types || this.dictionaries.industries, []);
      return options
        .filter((item) => this.optionMatchesSubject(item))
        .filter((item) => this.optionMatchesSettlement(item));
    },
    qualificationOptions() {
      const options = this.availableQualificationTypes;
      return withCurrentOption(options, this.form.settlement.qualification_type, "已保存的所属行业");
    },
    regionOptions() {
      return normalizeOptions(this.dictionaries.regions || this.dictionaries.address_codes, []);
    },
    businessRegionOptions() {
      return withCurrentOption(this.regionOptions, this.form.business.address_code, "已保存的经营地区");
    },
    bankRegionOptions() {
      return withCurrentOption(this.bankCityOptions, this.form.bank_account.bank_address_code, "已保存的开户城市");
    },
    hasBankBranchDictionary() {
      return this.bankBranchList.length > 0;
    },
    hasSavedBranchNameOnly() {
      return !!(this.form.bank_account.bank_branch_name && !this.form.bank_account.bank_branch_id);
    },
    savedBankBranchLabel() {
      return this.form.bank_account.bank_branch_name
        ? `已保存的开户支行：${this.form.bank_account.bank_branch_name}`
        : "已保存的开户支行";
    },
    bankBranchOptions() {
      return withCurrentOption(
        this.bankBranchList,
        this.form.bank_account.bank_branch_id,
        this.savedBankBranchLabel
      );
    },
    currentBank() {
      return this.findBankOptionByKey(this.bankSelectKey) || this.findSelectedBankOption() || {};
    },
    currentBankNeedBranch() {
      if (this.form.bank_account.need_bank_branch === 0 || this.form.bank_account.need_bank_branch === false) return false;
      if (this.currentBank.need_bank_branch === false) return false;
      return true;
    },
    canQueryBankBranch() {
      return !!(this.currentBankNeedBranch && this.form.bank_account.bank_alias_code && this.form.bank_account.bank_address_code);
    },
    subjectTypeText() {
      const item = this.subjectTypeOptions.find((option) => option.value === this.form.subject.subject_type);
      return item ? item.label : "企业";
    },
    usesBusinessLicense() {
      return ["SUBJECT_TYPE_INDIVIDUAL", "SUBJECT_TYPE_ENTERPRISE"].indexOf(this.form.subject.subject_type) !== -1;
    },
    requiresCertificateType() {
      return !this.usesBusinessLicense;
    },
    subjectLicenseFileType() {
      return this.usesBusinessLicense ? "business_license_copy" : "certificate_copy";
    },
    licenseNameLabel() {
      return this.usesBusinessLicense ? "商户名称" : "机构名称";
    },
    licenseNumberLabel() {
      return this.usesBusinessLicense ? "信用代码" : "登记证书编号";
    },
    registeredAddressLabel() {
      return this.usesBusinessLicense ? "注册地址" : "登记地址";
    },
    legalPersonLabel() {
      if (this.form.subject.subject_type === "SUBJECT_TYPE_INDIVIDUAL") return "经营者";
      if (this.usesBusinessLicense) return "法人代表";
      return "负责人";
    },
    weworkSceneSelected() {
      return this.sceneSelected("SALES_SCENES_WEWORK") || this.sceneSelected("SALES_SCENES_ENTERPRISE_WECHAT");
    },
    isHandlerContact() {
      return this.form.contact.contact_type === "SUPER" || this.form.contact.contact_type === "HANDLER";
    },
    isLongTerm() {
      return Number(this.form.subject.card_period_long_term) === 1;
    },
    isContactLongTerm() {
      return Number(this.form.contact.contact_period_long_term) === 1 || this.form.contact.contact_period_end === "长期";
    },
    settlementRateText() {
      const current = this.settlementOptions.find((item) => item.value === this.form.settlement.settlement_id);
      return (current && current.rate) || this.form.settlement.settlement_rate || "选择结算规则后带出";
    },
    qualificationMaterialTip() {
      const current = this.qualificationOptions.find((item) => item.value === this.form.settlement.qualification_type);
      return (current && current.qualification_tip) || "部分行业需要额外资质图片，未要求时可不上传。";
    },
    currentQualificationRequiresMaterial() {
      const current = this.qualificationOptions.find((item) => item.value === this.form.settlement.qualification_type);
      return truthyFlag(current && current.requires_qualification);
    },
    providerMissingText() {
      const ready = this.prefill.provider_ready;
      if (ready !== false && Number(ready) !== 0) return "";
      const missing = this.prefill.provider_missing_fields || [];
      if (Array.isArray(missing) && missing.length) {
        return `微信服务商配置未完成：${missing.join("、")}`;
      }
      return "微信服务商配置未完成，请先补齐服务商资料。";
    },
    confirmUrl() {
      return confirmUrlForApplyment(this.applyment, this.profile, this.form);
    },
    confirmQr() {
      if (!this.confirmUrl) return "";
      return confirmQrForUrl(this.confirmUrl, (value) => QR.createQrCodeImg(value, { size: 220 }));
    },
    missingByModule() {
      return this.collectMissingByModule();
    },
    missingLabels() {
      return Object.keys(this.missingByModule).reduce((result, key) => result.concat(this.missingByModule[key]), []);
    },
    additionNeedsSupplement() {
      return this.hasSupplementSignal(this.applyment) || this.hasSupplementSignal(this.profile);
    },
    currentApplymentStatus() {
      return applymentStatusValue(this.applyment, this.profile);
    },
    canSubmitApplyment() {
      return canSubmitApplyment(this.currentApplymentStatus);
    },
    canSyncApplymentStatus() {
      return canSyncApplymentStatus(this.currentApplymentStatus);
    },
    canShowConfirmCode() {
      return canShowApplymentConfirmCode(this.currentApplymentStatus, this.confirmUrl);
    },
    canSyncConfirmStatus() {
      return canSyncApplymentConfirm(this.currentApplymentStatus, this.confirmUrl);
    },
    canCheckReadiness() {
      return canCheckApplymentReadiness(this.currentApplymentStatus);
    },
    draftDisabled() {
      return this.loading || this.saving || !canSaveApplymentDraft(this.currentApplymentStatus);
    },
    submitDisabled() {
      return (
        this.loading ||
        this.saving ||
        this.submitting ||
        !this.canSubmitApplyment ||
        !!this.providerMissingText ||
        !!this.missingLabels.length
      );
    },
    syncDisabled() {
      return this.loading || this.syncingStatus || !this.canSyncApplymentStatus || (this.isShopMode && !this.applyment.id);
    },
    checkDisabled() {
      return this.loading || this.checkingReady || !this.canCheckReadiness || (this.isShopMode && !this.profile.id);
    },
    syncConfirmDisabled() {
      return this.loading || this.confirmSyncing || !this.canSyncConfirmStatus || (this.isShopMode && !this.applyment.id);
    },
  },
  watch: {
    mode: {
      immediate: true,
      handler(value) {
        if (value !== "shop" && value !== "store") {
          eltips("商户资料页面模式无效", "error");
        }
      },
    },
    isLongTerm(value) {
      if (value) this.form.subject.card_period_end = "长期";
    },
    isContactLongTerm(value) {
      if (value) this.form.contact.contact_period_end = "长期";
    },
    "form.contact.contact_type"(value) {
      if ((value === "SUPER" || value === "HANDLER") && !this.form.contact.contact_id_doc_type) {
        this.$set(this.form.contact, "contact_id_doc_type", "IDENTIFICATION_TYPE_IDCARD");
      }
    },
    "form.subject.subject_type"(value, oldValue) {
      if (value !== oldValue) this.handleSubjectTypeChange();
    },
  },
  created() {
    const queryStoreId = this.$route && this.$route.query ? this.$route.query.store_id : "";
    if (this.isShopMode && queryStoreId !== undefined && queryStoreId !== "") {
      this.form.store_id = Number(queryStoreId);
    }
    this.loadInitial();
  },
  methods: {
    isOk(res) {
      return res && (res.code === 200 || res.status === 200);
    },
    msg(res, fallback) {
      return (res && (res.msg || res.message)) || fallback;
    },
    responseData(res) {
      return (res && res.data) || {};
    },
    resetApplymentContext(preserveStoreId = true) {
      const storeId = preserveStoreId ? Number(this.form.store_id || 0) : 0;
      this.activeModule = "contact";
      this.form = emptyForm();
      this.form.store_id = storeId;
      this.prefill = {};
      this.applyment = {};
      this.profile = {};
      this.responseFormData = {};
      this.files = [];
      this.bankOptions = [];
      this.bankCityOptions = [];
      this.bankBranchList = [];
    },
    loadInitial() {
      this.loading = true;
      if (this.isCreateMode) {
        this.resetApplymentContext(true);
      }
      const tasks = [this.loadDictionaries()];
      if (this.isShopMode) {
        tasks.push(this.loadStores());
        if (this.id) {
          tasks.push(this.loadShopDetail(this.id).then(() => this.loadPrefill()));
        } else {
          tasks.push(this.loadPrefill());
        }
      } else {
        tasks.push(this.loadPrefill());
        tasks.push(this.loadStoreDetail());
      }

      Promise.all(tasks)
        .then(() => {
          this.refreshForm();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadDictionaries() {
      if (this.isStoreMode) {
        this.dictionaries = this.storeDictionariesWithFallback();
        return Promise.resolve();
      }
      return getApplymentDictionaries().then((res) => {
        if (this.isOk(res)) {
          this.dictionaries = this.responseData(res);
        } else {
          eltips(this.msg(res, "获取字典失败"), "error");
        }
      });
    },
    loadPrefill() {
      const request = this.isShopMode
        ? getApplymentPrefill({
          store_id: this.form.store_id,
          fresh: this.isCreateMode ? 1 : 0,
        })
        : getStoreApplymentPrefill();
      return request.then((res) => {
        if (this.isOk(res)) {
          const data = this.responseData(res);
          this.prefill = data;
          if (this.isCreateMode) {
            this.applyment = {};
            this.profile = {};
            this.responseFormData = {};
            this.files = [];
          }
          if (this.isStoreMode) this.applyStoreDictionaries(data);
        } else {
          eltips(this.msg(res, "获取预填资料失败"), "error");
        }
      });
    },
    loadStores() {
      return this.axios
        .get(resolveWeiShopApi("/api/weishop/admin/plugin/store/information/index"), { params: { page: 1, limit: 500 } })
        .then((res) => {
          if (!this.isOk(res)) return;
          const data = this.responseData(res);
          const list = (((data || {}).data || {}).data || (data || {}).data || []);
          this.storeList = Array.isArray(list) ? list : [];
          this.storeMap = { 0: STORE_PLATFORM_LABEL };
          this.storeList.forEach((item) => {
            this.$set(this.storeMap, Number(item.id), item.title);
          });
        });
    },
    loadShopDetail(id) {
      return getApplyment(id).then((res) => {
        if (this.isOk(res)) {
          this.applyDetail(this.responseData(res));
        } else {
          eltips(this.msg(res, "获取商户资料失败"), "error");
        }
      });
    },
    loadStoreDetail() {
      return getStoreApplyment().then((res) => {
        if (this.isOk(res)) {
          this.applyDetail(this.responseData(res));
        } else {
          eltips(this.msg(res, "获取商户资料失败"), "error");
        }
      });
    },
    applyDetail(data) {
      this.applyment = data.applyment || {};
      this.profile = data.profile || {};
      this.responseFormData = data.form_data || {};
      this.files = data.files || [];
      if (data.prefill) {
        this.prefill = data.prefill;
        if (this.isStoreMode) this.applyStoreDictionaries(data.prefill);
      }
      if (data.dictionaries) {
        this.dictionaries = this.isStoreMode
          ? this.storeDictionariesWithFallback(this.dictionaries, data.dictionaries)
          : data.dictionaries;
      }
      if (this.isShopMode) {
        this.form.store_id = Number(this.applyment.store_id || this.profile.store_id || this.form.store_id || 0);
      }
      this.refreshForm();
    },
    refreshForm() {
      const savedData = this.savedFormData();
      const nextForm = mergePrefill(savedData, this.prefill);
      nextForm.store_id = this.isStoreMode
        ? Number(nextForm.store_id || this.profile.store_id || 0)
        : Number(nextForm.store_id || this.form.store_id || 0);
      nextForm.applyment_type = "standard";
      if (!isPlainObject(nextForm.addition_info)) nextForm.addition_info = {};
      if (!Object.prototype.hasOwnProperty.call(nextForm.addition_info, "description")) {
        nextForm.addition_info.description = "";
      }
      this.form = nextForm;
      this.normalizeLegacyQualificationType();
      this.mergeFilesToForm();
      this.loadBankDictionaries();
    },
    updateFundsAdditionMessage(sources = [], uses = []) {
      if (!isPlainObject(this.form.addition_info)) {
        this.$set(this.form, "addition_info", {});
      }

      this.$set(
        this.form.addition_info,
        "description",
        buildFundsAdditionMessage(Array.from(new Set(sources)), Array.from(new Set(uses)))
      );
    },
    savedFormData() {
      if (this.isCreateMode) return {};
      const candidates = [
        this.applyment.form_data,
        this.responseFormData,
        this.applyment.applyment_data,
        this.profile.applyment_data,
      ];
      return candidates.find((item) => !isEmptyValue(item)) || {};
    },
    mergeFilesToForm() {
      const files = clone(this.form.files || {});
      (this.files || []).forEach((file) => {
        if (!file || !file.file_type) return;
        const fileType = this.canonicalFileType(file.file_type);
        if (this.isMultipleFileType(fileType)) {
          const limit = this.fileTypeLimit(fileType);
          const currentList = asMaterialList(files[fileType]);
          const current = currentList.find((item) => materialKey(item) === materialKey(file)) || {};
          files[fileType] = upsertMaterialList(
            currentList,
            normalizeServerMaterial(file, current),
            limit
          );
          return;
        }

        files[fileType] = normalizeServerMaterial(file, files[fileType] || {});
      });
      this.$set(this.form, "files", files);
      Object.keys(files).forEach((type) => {
        if (Array.isArray(files[type])) return;
        if (files[type].media_id) this.applyMediaId(type, files[type].media_id);
      });
    },
    handleStoreChange() {
      this.loadPrefill().then(() => {
        this.applyment = {};
        this.profile = {};
        this.responseFormData = {};
        this.files = [];
        this.refreshForm();
      });
    },
    loadBankDictionaries() {
      this.loadWechatBanks();
      this.loadBankProvinces();
      if (this.form.bank_account.bank_province_code) {
        this.loadBankCities(this.form.bank_account.bank_province_code);
      }
      if (this.canQueryBankBranch) {
        this.loadBankBranches();
      }
    },
    loadWechatBanks(keyword = this.bankSearchKeyword) {
      if (this.bankLoading) return Promise.resolve();
      this.bankLoading = true;
      this.bankSearchKeyword = keyword || "";
      const request = this.isShopMode ? getApplymentBanks : getStoreApplymentBanks;
      return request({
        account_type: this.form.bank_account.bank_account_type,
        keyword: this.bankSearchKeyword,
        limit: this.bankSearchKeyword ? 50 : 200,
      }).then((res) => {
        if (this.isOk(res)) {
          const data = this.responseData(res);
          this.bankOptions = normalizeOptions(data.data || [], []);
          this.applySelectedBankMeta();
        }
      }).finally(() => {
        this.bankLoading = false;
      });
    },
    searchWechatBanks(keyword) {
      this.loadWechatBanks((keyword || "").trim());
    },
    loadBankProvinces() {
      if (this.bankProvinceLoading || this.bankProvinceOptions.length) return Promise.resolve();
      this.bankProvinceLoading = true;
      const request = this.isShopMode ? getApplymentBankProvinces : getStoreApplymentBankProvinces;
      return request().then((res) => {
        if (this.isOk(res)) {
          const data = this.responseData(res);
          this.bankProvinceOptions = normalizeOptions(data.data || [], []);
        }
      }).finally(() => {
        this.bankProvinceLoading = false;
      });
    },
    loadBankCities(provinceCode) {
      if (!provinceCode) {
        this.bankCityOptions = [];
        return Promise.resolve();
      }
      this.bankCityLoading = true;
      const request = this.isShopMode ? getApplymentBankCities : getStoreApplymentBankCities;
      return request({ province_code: provinceCode }).then((res) => {
        if (this.isOk(res)) {
          const data = this.responseData(res);
          this.bankCityOptions = normalizeOptions(data.data || [], []);
        }
      }).finally(() => {
        this.bankCityLoading = false;
      });
    },
    loadBankBranches(keyword = this.bankBranchSearchKeyword) {
      if (!this.canQueryBankBranch) {
        this.bankBranchList = [];
        return Promise.resolve();
      }
      this.bankBranchLoading = true;
      this.bankBranchSearchKeyword = keyword || "";
      const request = this.isShopMode ? getApplymentBankBranches : getStoreApplymentBankBranches;
      return request({
        bank_alias_code: this.form.bank_account.bank_alias_code,
        city_code: this.form.bank_account.bank_address_code,
        keyword: this.bankBranchSearchKeyword,
        limit: this.bankBranchSearchKeyword ? 50 : 200,
      }).then((res) => {
        if (this.isOk(res)) {
          const data = this.responseData(res);
          this.bankBranchList = normalizeOptions(data.data || [], []);
        }
      }).finally(() => {
        this.bankBranchLoading = false;
      });
    },
    searchBankBranches(keyword) {
      this.loadBankBranches((keyword || "").trim());
    },
    handleBankAccountTypeChange() {
      this.bankOptions = [];
      this.bankBranchList = [];
      this.bankSelectKey = "";
      this.bankSearchKeyword = "";
      this.bankBranchSearchKeyword = "";
      this.$set(this.form.bank_account, "account_bank", "");
      this.$set(this.form.bank_account, "bank_name", "");
      this.$set(this.form.bank_account, "account_bank_code", "");
      this.$set(this.form.bank_account, "bank_alias", "");
      this.$set(this.form.bank_account, "bank_alias_code", "");
      this.$set(this.form.bank_account, "need_bank_branch", 1);
      this.$set(this.form.bank_account, "bank_branch_id", "");
      this.$set(this.form.bank_account, "bank_branch_name", "");
      this.loadWechatBanks();
    },
    bankOptionKey(item, index) {
      return [
        item.bank_alias_code,
        item.account_bank_code,
        item.value,
        item.label,
        index,
      ].filter((value) => !isEmptyValue(value)).join("|");
    },
    findBankOptionByKey(key) {
      if (!key) return null;
      return this.commonBanks.find((item, index) => String(this.bankOptionKey(item, index)) === String(key)) || null;
    },
    findSelectedBankOption() {
      const aliasCode = this.form.bank_account.bank_alias_code;
      if (aliasCode) {
        const byAlias = this.commonBanks.find((item) => String(item.bank_alias_code || "") === String(aliasCode));
        if (byAlias) return byAlias;
      }

      return this.commonBanks.find((item) => String(item.value) === String(this.form.bank_account.account_bank)) || null;
    },
    syncBankSelectKey() {
      const bank = this.findSelectedBankOption();
      if (!bank) {
        this.bankSelectKey = "";
        return;
      }

      const index = this.commonBanks.indexOf(bank);
      this.bankSelectKey = this.bankOptionKey(bank, index < 0 ? 0 : index);
    },
    handleBankChange(value) {
      const bank = this.findBankOptionByKey(value);
      this.$set(this.form.bank_account, "account_bank", bank ? (bank.account_bank || bank.value || "") : "");
      this.$set(this.form.bank_account, "bank_name", bank ? (bank.account_bank || bank.label) : "");
      this.$set(this.form.bank_account, "account_bank_code", bank ? (bank.account_bank_code || "") : "");
      this.$set(this.form.bank_account, "bank_alias", bank ? (bank.bank_alias || bank.label || "") : "");
      this.$set(this.form.bank_account, "bank_alias_code", bank ? (bank.bank_alias_code || "") : "");
      this.$set(this.form.bank_account, "need_bank_branch", bank && bank.need_bank_branch === false ? 0 : 1);
      this.$set(this.form.bank_account, "bank_branch_id", "");
      this.$set(this.form.bank_account, "bank_branch_name", "");
      this.bankBranchList = [];
      this.bankBranchSearchKeyword = "";
      if (this.canQueryBankBranch) this.loadBankBranches();
    },
    applySelectedBankMeta() {
      this.syncBankSelectKey();
      if (!this.form.bank_account.account_bank || this.form.bank_account.bank_alias_code) return;
      const bank = this.findSelectedBankOption();
      if (!bank) return;
      this.$set(this.form.bank_account, "bank_name", bank.account_bank || bank.label || "");
      this.$set(this.form.bank_account, "account_bank_code", bank.account_bank_code || "");
      this.$set(this.form.bank_account, "bank_alias", bank.bank_alias || bank.label || "");
      this.$set(this.form.bank_account, "bank_alias_code", bank.bank_alias_code || "");
      this.$set(this.form.bank_account, "need_bank_branch", bank.need_bank_branch === false ? 0 : 1);
    },
    handleBankProvinceChange(value) {
      this.$set(this.form.bank_account, "bank_address_code", "");
      this.$set(this.form.bank_account, "bank_branch_id", "");
      this.$set(this.form.bank_account, "bank_branch_name", "");
      this.bankCityOptions = [];
      this.bankBranchList = [];
      this.bankBranchSearchKeyword = "";
      this.loadBankCities(value);
    },
    handleBankCityChange() {
      this.$set(this.form.bank_account, "bank_branch_id", "");
      this.$set(this.form.bank_account, "bank_branch_name", "");
      this.bankBranchList = [];
      this.bankBranchSearchKeyword = "";
      this.loadBankBranches();
    },
    handleBankBranchChange(value) {
      const branch = this.bankBranchOptions.find((item) => String(item.value) === String(value));
      this.$set(this.form.bank_account, "bank_branch_name", branch ? (branch.bank_branch_name || branch.label) : "");
      if (branch && this.currentBankNeedBranch) {
        this.$set(this.form.bank_account, "bank_name", branch.bank_branch_name || branch.label || "");
      }
    },
    optionValues(value) {
      if (Array.isArray(value)) return value.map((item) => String(item));
      if (value === undefined || value === null || value === "") return [];
      return [String(value)];
    },
    optionMatchesSubject(item) {
      const subjects = this.optionValues(item.subject_types || item.subject_type);
      if (!subjects.length) return true;
      return subjects.indexOf(String(this.form.subject.subject_type)) !== -1;
    },
    optionMatchesSettlement(item) {
      const settlementId = String(this.form.settlement.settlement_id || "");
      if (!settlementId) return true;
      const ids = this.optionValues(item.settlement_ids || item.settlement_id);
      if (!ids.length) return true;
      return ids.indexOf(settlementId) !== -1;
    },
    findQualificationOption(value) {
      const qualificationType = this.officialQualificationType(value);
      const currentIndustryId = String((this.form.settlement && this.form.settlement.industry_id) || "");
      const dictionaries = normalizeOptions(this.dictionaries.qualification_types || this.dictionaries.industries, []);
      return dictionaries.find((item) => {
        if (currentIndustryId && String(item.industry_id || "") === currentIndustryId) {
          return this.optionMatchesSubject(item) && this.optionMatchesSettlement(item);
        }
        const names = [
          item.value,
          item.official_name,
          item.label,
        ].map((name) => String(name || ""));
        if (names.indexOf(String(qualificationType || "")) === -1) return false;
        return this.optionMatchesSubject(item) && this.optionMatchesSettlement(item);
      });
    },
    syncQualificationIndustryId(value = this.form.settlement.qualification_type) {
      const qualification = this.findQualificationOption(value);
      this.$set(this.form.settlement, "industry_id", qualification ? String(qualification.industry_id || "") : "");
    },
    handleSubjectTypeChange() {
      const settlementId = String(this.form.settlement.settlement_id || "");
      if (settlementId && !this.availableSettlementRules.some((item) => String(item.value) === settlementId)) {
        this.$set(this.form.settlement, "settlement_id", "");
        this.$set(this.form.settlement, "settlement_rate", "");
      }

      const qualificationType = String(this.form.settlement.qualification_type || "");
      if (qualificationType && !this.availableQualificationTypes.some((item) => String(item.value) === qualificationType)) {
        this.$set(this.form.settlement, "qualification_type", "");
        this.$set(this.form.settlement, "industry_id", "");
      } else {
        this.syncQualificationIndustryId(qualificationType);
      }
    },
    handleQualificationChange(value) {
      const qualification = this.availableQualificationTypes.find((item) => String(item.value) === String(value));
      if (!qualification) return;

      this.$set(this.form.settlement, "industry_id", String(qualification.industry_id || ""));

      const currentSettlementId = String(this.form.settlement.settlement_id || "");
      const allowedSettlementIds = this.optionValues(qualification.settlement_ids || qualification.settlement_id);
      if (currentSettlementId && allowedSettlementIds.indexOf(currentSettlementId) !== -1) return;

      const settlement = this.availableSettlementRules.find((item) => allowedSettlementIds.indexOf(String(item.value)) !== -1);
      if (settlement) {
        this.$set(this.form.settlement, "settlement_id", settlement.value);
        this.handleSettlementChange(settlement.value);
      }
    },
    handleSettlementChange(value) {
      const settlement = this.availableSettlementRules.find((item) => String(item.value) === String(value))
        || this.settlementOptions.find((item) => String(item.value) === String(value));
      if (settlement && settlement.rate) {
        this.$set(this.form.settlement, "settlement_rate", settlement.rate);
      } else {
        this.$set(this.form.settlement, "settlement_rate", "");
      }

      const qualificationType = String(this.form.settlement.qualification_type || "");
      if (qualificationType && !this.availableQualificationTypes.some((item) => String(item.value) === qualificationType)) {
        this.$set(this.form.settlement, "qualification_type", "");
        this.$set(this.form.settlement, "industry_id", "");
      } else {
        this.syncQualificationIndustryId(qualificationType);
      }
    },
    buildPayload() {
      const payload = clone(this.form);
      payload.applyment_type = "standard";
      delete payload.business_code;
      if (this.isLongTerm) payload.subject.card_period_end = "长期";
      if (this.isContactLongTerm) payload.contact.contact_period_end = "长期";
      payload.business.mini_program_sub_appid = (payload.business.mini_program_sub_appid || "").trim();
      this.normalizePayloadContract(payload);
      if (this.isStoreMode) delete payload.store_id;
      return payload;
    },
    normalizePayloadContract(payload) {
      if (!payload.business) payload.business = {};
      if (!payload.files) payload.files = {};
      if (payload.settlement && payload.settlement.qualification_type) {
        payload.settlement.qualification_type = this.officialQualificationType(payload.settlement.qualification_type);
        const qualification = this.findQualificationOption(payload.settlement.qualification_type);
        if (qualification) {
          payload.settlement.qualification_type = qualification.official_name || qualification.value || payload.settlement.qualification_type;
          payload.settlement.industry_id = String(qualification.industry_id || "");
        } else {
          payload.settlement.industry_id = String(payload.settlement.industry_id || "");
        }
      }
      if (Array.isArray(payload.business.sales_scenes_type)) {
        payload.business.sales_scenes_type = payload.business.sales_scenes_type.map((scene) =>
          scene === "SALES_SCENES_ENTERPRISE_WECHAT" ? "SALES_SCENES_WEWORK" : scene
        );
      }
      if (!payload.business.sub_corp_id && payload.business.enterprise_wechat_corpid) {
        payload.business.sub_corp_id = payload.business.enterprise_wechat_corpid;
      }
      delete payload.business.enterprise_wechat_corpid;
      if (payload.settlement) {
        delete payload.settlement.qualifications;
      }
      this.movePayloadFile(payload.files, "web_authorisation", "web_authorization_letter");
      this.movePayloadFile(payload.files, "wework_pics", "enterprise_wechat_pics");
    },
    movePayloadFile(files, key, oldKey) {
      if (isEmptyValue(files[key]) && !isEmptyValue(files[oldKey])) {
        files[key] = files[oldKey];
      }
      delete files[oldKey];
    },
    officialQualificationType(value) {
      const key = String(value || "");
      const aliases = (this.dictionaries && (this.dictionaries.qualification_aliases || this.dictionaries.industry_aliases)) || {};
      return aliases[key] || key;
    },
    normalizeLegacyQualificationType() {
      const current = String((this.form.settlement && this.form.settlement.qualification_type) || "");
      const next = this.officialQualificationType(current);
      const qualification = this.findQualificationOption(next || current);
      if (current && next !== current) {
        this.$set(this.form.settlement, "qualification_type", next);
      }
      if (qualification && qualification.value && String(this.form.settlement.qualification_type || "") !== String(qualification.value)) {
        this.$set(this.form.settlement, "qualification_type", qualification.official_name || qualification.value);
      }
      this.syncQualificationIndustryId((qualification && qualification.value) || next || current);
    },
    saveDraft(options = {}) {
      const silent = options && options.silent === true;
      const throwOnError = options && options.throwOnError === true;
      this.saving = true;
      const request = this.isShopMode
        ? saveApplyment({
          store_id: Number(this.form.store_id || 0),
          applyment_id: Number(this.applyment.id || 0),
          applyment_data: this.buildPayload(),
        })
        : saveStoreApplyment({ applyment_data: this.buildPayload() });
      return request
        .then((res) => {
          if (this.isOk(res)) {
            if (!silent) eltips(this.msg(res, "保存成功"), "success");
            const data = this.responseData(res);
            this.applyDetail(data);
            if (!silent) this.replaceRouteWithSavedDraft(data);
            return data;
          } else {
            const message = this.msg(res, "保存失败");
            if (!silent) eltips(message, "error");
            if (throwOnError) throw new Error(message);
            return null;
          }
        })
        .finally(() => {
          this.saving = false;
        });
    },
    replaceRouteWithSavedDraft(data) {
      if (!this.isShopMode || this.id || !this.$router || !this.$route) return;
      const applyment = (data && data.applyment) || this.applyment || {};
      const id = applyment.id;
      if (!id) return;

      const query = Object.assign({}, this.$route.query, { id });
      delete query._t;
      this.$router.replace({
        path: this.$route.path,
        query,
      }).catch(() => {});
    },
    submitCurrent() {
      if (this.submitDisabled) {
        if (this.missingLabels.length) this.goFirstMissing();
        return;
      }
      this.submitting = true;
      this.saveDraft({ silent: true, throwOnError: true })
        .then((data) => {
          const applyment = (data && data.applyment) || this.applyment || {};
          if (this.isShopMode && !applyment.id) {
            throw new Error("请先保存微信收款商户资料");
          }
          return this.isShopMode ? submitApplyment(applyment.id) : submitStoreApplyment();
        })
        .then((res) => {
          if (this.isOk(res)) {
            eltips(this.msg(res, "提交成功"), "success");
            if (this.isShopMode) {
              this.$router.replace({ path: this.applymentListPath });
              return;
            }
            this.applyDetail(this.responseData(res));
            this.activeModule = "addition";
          } else {
            eltips(this.msg(res, "提交失败"), "error");
          }
        })
        .catch((error) => {
          eltips((error && error.message) || "提交失败", "error");
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    syncCurrent() {
      if (this.syncDisabled) return;
      this.syncingStatus = true;
      const request = this.isShopMode ? syncApplyment(this.applyment.id) : syncStoreApplyment();
      request
        .then((res) => {
          if (this.isOk(res)) {
            eltips(this.msg(res, "同步成功"), "success");
            this.applyDetail(this.responseData(res));
          } else {
            eltips(this.msg(res, "同步失败"), "error");
          }
        })
        .finally(() => {
          this.syncingStatus = false;
        });
    },
    syncConfirmStatus() {
      if (this.syncConfirmDisabled) return;
      this.confirmSyncing = true;
      const request = this.isShopMode ? syncApplymentConfirm(this.applyment.id) : syncStoreApplymentConfirm();
      request
        .then((res) => {
          if (this.isOk(res)) {
            eltips(this.msg(res, "同步成功"), "success");
            this.applyDetail(this.responseData(res));
          } else {
            eltips(this.msg(res, "同步失败"), "error");
          }
        })
        .finally(() => {
          this.confirmSyncing = false;
        });
    },
    checkReady() {
      if (this.checkDisabled) return;
      this.checkingReady = true;
      const request = this.isShopMode ? checkProfileReadiness(this.profile.id) : checkStoreProfileReadiness();
      request
        .then((res) => {
          if (this.isOk(res)) {
            eltips(this.msg(res, "检查成功"), "success");
            const data = this.responseData(res);
            this.profile = data.profile || this.profile;
            if (data.applyment) this.applyment = data.applyment;
          } else {
            eltips(this.msg(res, "检查失败"), "error");
          }
        })
        .finally(() => {
          this.checkingReady = false;
        });
    },
    pickFile(type) {
      const fileType = this.canonicalFileType(type);
      const isMultiple = this.isMultipleFileType(fileType);
      const limit = this.fileTypeLimit(fileType);
      const currentCount = isMultiple ? asMaterialList(this.form.files[fileType]).length : 0;
      const remaining = Math.max(limit - currentCount, 0);
      if (isMultiple && remaining <= 0) {
        eltips(`最多上传 ${limit} 张，请先删除不需要的图片`, "warning");
        return;
      }
      this.imagePicker.fileType = fileType;
      this.imagePicker.multiple = isMultiple;
      this.imagePicker.count = isMultiple ? remaining : 1;
      this.imagePicker.show = true;
    },
    onAssetPicked(obj) {
      const type = this.imagePicker.fileType;
      const assets = (obj && Array.isArray(obj.imgobjs) ? obj.imgobjs : []).filter((item) => item && item.id);
      if (!assets.length) return;

      if (this.isMultipleFileType(type)) {
        const limit = this.fileTypeLimit(type);
        const currentList = asMaterialList(this.form.files[type]);
        const remaining = Math.max(limit - currentList.length, 0);
        const selected = assets.slice(0, remaining).reduce((result, asset) => {
          const current = currentList.find((item) => String(item.asset_id || "") === String(asset.id || "")) || {};
          return upsertMaterialList(result, normalizeAssetMaterial(asset, current), limit);
        }, currentList.slice(0, limit));
        this.$set(this.form.files, type, selected);
        return;
      }

      const asset = assets[0];
      const current = this.form.files[type] || {};
      this.$set(this.form.files, type, {
        ...normalizeAssetMaterial(asset, current),
        media_id: "",
        recognized_at: "",
        recognize_status: this.isRecognizable(type) ? "recognizing" : "uploaded",
      });
      if (this.isRecognizable(type)) this.recognizeFile(type);
    },
    removeFile(type, index) {
      const fileType = this.canonicalFileType(type);
      if (this.isMultipleFileType(fileType)) {
        const next = asMaterialList(this.form.files[fileType]).filter((item, itemIndex) => itemIndex !== index);
        this.$set(this.form.files, fileType, next);
        if (fileType === "qualifications") {
          this.$set(
            this.form.settlement,
            "qualifications",
            next.map((item) => item && item.media_id).filter(Boolean)
          );
        }
        return;
      }
      this.$set(this.form.files, fileType, {});
      if (this.isRecognizable(fileType)) {
        this.$delete(this.form.ocr_snapshots, fileType);
      }
    },
    recognizeFile(type) {
      const material = this.form.files[type] || {};
      if (!material.asset_id && !material.media_id) return;
      this.recognizingType = type;
      const payload = {
        file_type: type,
        asset_id: material.asset_id,
        media_id: material.media_id,
      };
      if (this.isShopMode) payload.store_id = Number(this.form.store_id || 0);
      const request = this.isShopMode ? recognizeApplymentFile(payload) : recognizeStoreApplymentFile(payload);
      request
        .then((res) => {
          if (this.isOk(res)) {
            const data = this.responseData(res);
            const fields = ocrFieldsFromResponse(data);
            this.applyRecognizedFields(type, fields || {});
            this.$set(this.form.ocr_snapshots, type, clone(fields));
            this.$set(this.form.files, type, {
              ...material,
              recognized_at: data.recognized_at || new Date().toISOString().slice(0, 19).replace("T", " "),
              recognize_status: "recognized",
            });
            if (data.file) this.upsertFile(data.file);
          } else {
            this.$set(this.form.files, type, {
              ...material,
              recognize_status: "failed",
            });
          }
        })
        .finally(() => {
          this.recognizingType = "";
        });
    },
    applyRecognizedFields(type, fields) {
      const source = fields || {};
      if (type === "business_license_copy" || type === "certificate_copy") {
        this.assignIfPresent(this.form.subject, "merchant_name", source.merchant_name || source.license_name || source.companyName || source.company_name || source.name);
        this.assignIfPresent(this.form.subject, "license_number", source.license_number || source.creditCode || source.credit_code || source.reg_num);
        this.assignIfPresent(this.form.subject, "legal_person", source.legal_person || source.legalPerson || source.legal_representative);
        this.assignIfPresent(this.form.subject, "registered_address", source.registered_address || source.businessAddress || source.registeredAddress || source.address);
        return;
      }

      if (type === "id_card_copy" || type === "id_card_national") {
        const validPeriod = splitOcrValidPeriod(source.validPeriod || source.valid_period || source.card_period || source["有效期限"]);
        this.assignIfPresent(this.form.subject, "id_card_name", source.id_card_name || source.Name || source.name);
        this.assignIfPresent(this.form.subject, "id_card_number", source.id_card_number || source.idNumber || source.idNum || source.number || source.id_number);
        this.assignIfPresent(this.form.subject, "id_card_address", source.id_card_address || source.address);
        this.assignIfPresent(this.form.subject, "card_period_begin", normalizeOcrDate(source.card_period_begin || source.validFromDate || source.startDate || source.valid_date_begin || validPeriod.begin));
        this.assignIfPresent(this.form.subject, "card_period_end", normalizeOcrDate(source.card_period_end || source.validToDate || source.endDate || source.valid_date_end || validPeriod.end));
        this.assignIfPresent(this.form.subject, "legal_person", source.legal_person || source.id_card_name || source.Name || source.name);
        return;
      }

      if (type === "contact_id_doc_copy" || type === "contact_id_doc_copy_back") {
        const validPeriod = splitOcrValidPeriod(source.validPeriod || source.valid_period || source.card_period || source["有效期限"]);
        this.assignIfPresent(this.form.contact, "contact_id_doc_type", source.contact_id_doc_type || "IDENTIFICATION_TYPE_IDCARD");
        this.assignIfPresent(this.form.contact, "contact_name", source.contact_name || source.id_card_name || source.Name || source.name);
        this.assignIfPresent(this.form.contact, "contact_id_number", source.contact_id_number || source.id_card_number || source.idNumber || source.idNum || source.number || source.id_number);
        this.assignIfPresent(this.form.contact, "contact_period_begin", normalizeOcrDate(source.contact_period_begin || source.card_period_begin || source.validFromDate || source.startDate || source.valid_date_begin || validPeriod.begin));
        const periodEnd = normalizeOcrDate(source.contact_period_end || source.card_period_end || source.validToDate || source.endDate || source.valid_date_end || validPeriod.end);
        this.assignIfPresent(this.form.contact, "contact_period_end", periodEnd);
        if (periodEnd === "长期") {
          this.$set(this.form.contact, "contact_period_long_term", 1);
        }
        return;
      }

      if (type === "bank_card_copy") {
        const bank = source.bank_account || source;
        [
          "bank_account_type",
          "account_name",
          "account_bank",
          "bank_address_code",
          "bank_name",
          "bank_branch_id",
          "bank_branch_name",
          "account_number",
        ].forEach((key) => {
          this.assignIfPresent(this.form.bank_account, key, bank[key]);
        });
      }
    },
    assignIfPresent(target, key, value, overwrite = false) {
      if (value !== undefined && value !== null && value !== "" && (overwrite || isEmptyValue(target[key]))) {
        this.$set(target, key, value);
      }
    },
    sceneSelected(scene) {
      return (this.form.business.sales_scenes_type || []).indexOf(scene) !== -1;
    },
    hasMaterial(type) {
      const material = (this.form.files || {})[type] || {};
      if (Array.isArray(material)) return material.some((item) => hasMaterialValue(item));
      return hasMaterialValue(material);
    },
    collectMissingByModule() {
      const result = {
        contact: [],
        subject: [],
        business: [],
        settlement: [],
        bank_account: [],
        addition: [],
      };
      const need = (module, condition, label) => {
        if (!condition) result[module].push(label);
      };

      need("contact", this.form.contact.contact_type, "联系人类型");
      need("contact", this.form.contact.contact_name, "联系人姓名");
      need("contact", this.form.contact.mobile_phone, "手机号");
      need("contact", this.form.contact.contact_email, "联系邮箱");
      if (this.isHandlerContact) {
        need("contact", this.form.contact.contact_id_doc_type, "经办人证件类型");
        need("contact", this.form.contact.contact_id_number, "经办人证件号码");
        need("contact", this.form.contact.contact_period_begin, "经办人证件有效期开始日期");
        need("contact", this.isContactLongTerm || this.form.contact.contact_period_end, "经办人证件有效期结束日期");
        need("contact", this.hasMaterial("contact_id_doc_copy"), "经办人证件正面照片");
        need("contact", this.hasMaterial("contact_id_doc_copy_back"), "经办人证件反面照片");
      }

      need("subject", this.form.subject.subject_type, "主体类型");
      need("subject", this.hasMaterial(this.subjectLicenseFileType), this.usesBusinessLicense ? "营业执照照片" : "登记证书照片");
      need("subject", this.form.subject.license_number, this.licenseNumberLabel);
      if (this.requiresCertificateType) need("subject", this.form.subject.cert_type, "登记证书类型");
      need("subject", this.form.subject.merchant_name, this.licenseNameLabel);
      need("subject", this.form.subject.registered_address, this.registeredAddressLabel);
      need("subject", this.form.subject.legal_person, this.legalPersonLabel);
      need("subject", this.form.subject.id_card_name, "身份证姓名");
      need("subject", this.form.subject.id_card_number, "身份证号");
      need("subject", this.hasMaterial("id_card_copy"), "身份证人像面");
      need("subject", this.hasMaterial("id_card_national"), "身份证国徽面");
      need("subject", this.form.subject.card_period_begin, "证件有效期开始日期");
      need("subject", this.isLongTerm || this.form.subject.card_period_end, "证件有效期结束日期");

      need("business", this.form.business.merchant_shortname, "商户简称");
      need("business", this.form.business.service_phone, "客服电话");
      need("business", Array.isArray(this.form.business.sales_scenes_type) && this.form.business.sales_scenes_type.length, "经营场景");
      if (this.sceneSelected("SALES_SCENES_MINI_PROGRAM")) {
        need("business", this.form.business.mini_program_sub_appid, "小程序 APPID");
      }
      if (this.sceneSelected("SALES_SCENES_STORE")) {
        need("business", this.form.business.store_name, "门店名称");
        need("business", this.form.business.address_code, "经营地区");
        need("business", this.form.business.address, "经营地址");
        need("business", this.hasMaterial("store_entrance_pic"), "门头照");
        need("business", this.hasMaterial("indoor_pic"), "店内照");
      }
      if (this.sceneSelected("SALES_SCENES_MP")) need("business", this.hasMaterial("mp_pics"), "公众号资料");
      if (this.sceneSelected("SALES_SCENES_APP")) need("business", this.hasMaterial("app_pics"), "App 资料");
      if (this.sceneSelected("SALES_SCENES_WEB")) need("business", this.hasMaterial("web_authorisation"), "网站资料");
      if (this.weworkSceneSelected) {
        need("business", this.form.business.sub_corp_id, "企业微信 CorpID");
        need("business", this.hasMaterial("wework_pics"), "企业微信资料");
      }

      need("settlement", this.form.settlement.qualification_type, "所属行业");
      need("settlement", this.form.settlement.settlement_id, "结算规则");
      if (this.currentQualificationRequiresMaterial) {
        need("settlement", this.hasMaterial("qualifications"), "特殊资质材料");
      }

      need("bank_account", this.form.bank_account.bank_account_type, "账户类型");
      need("bank_account", this.form.bank_account.account_name, "开户名称");
      need("bank_account", this.form.bank_account.account_bank, "开户银行");
      if (this.currentBankNeedBranch) {
        need("bank_account", this.form.bank_account.bank_address_code, "开户城市");
        need("bank_account", this.form.bank_account.bank_branch_id, "开户支行");
      }
      need("bank_account", this.form.bank_account.account_number, "银行账号");

      return result;
    },
    moduleStatusText(key) {
      const module = this.modules.find((item) => item.key === key) || {};
      const missing = this.missingByModule[key] || [];
      if (missing.length) return "有缺项";
      if (key === "addition" && this.additionNeedsSupplement) {
        return this.moduleHasData(key) ? "已完成" : "需补充";
      }
      if (module.optional) return this.moduleHasData(key) ? "已完成" : "可选";
      return this.moduleHasData(key) ? "已完成" : "未填写";
    },
    moduleStatusType(key) {
      const module = this.modules.find((item) => item.key === key) || {};
      const missing = this.missingByModule[key] || [];
      if (missing.length) return "danger";
      if (key === "addition" && this.additionNeedsSupplement) {
        return this.moduleHasData(key) ? "success" : "warning";
      }
      if (module.optional) return this.moduleHasData(key) ? "success" : "info";
      return this.moduleHasData(key) ? "success" : "info";
    },
    moduleHasData(key) {
      if (key === "addition") {
        return !!(this.form.addition_info.description || this.hasMaterial("business_addition_pics"));
      }
      const value = this.form[key];
      if (!isPlainObject(value)) return !isEmptyValue(value);
      return Object.keys(value).some((item) => !isEmptyValue(value[item]));
    },
    hasSupplementSignal(source = {}) {
      if (!isPlainObject(source)) return false;

      const directReason = source.reject_reason || source.rejectReason || source.fail_reason || source.failReason;
      if (hasMeaningfulValue(directReason)) return true;

      if (hasSupplementStatus(source, ["status", "applyment_status", "applyment_state", "material_state"])) return true;

      const directFlags = [
        source.addition_required,
        source.additionRequired,
        source.supplement_required,
        source.supplementRequired,
        source.need_supplement,
        source.needSupplement,
      ];
      if (directFlags.some((value) => truthyFlag(value))) return true;

      const details = [
        source.audit_detail,
        source.auditDetail,
        source.status_response_snapshot,
        source.statusResponseSnapshot,
        source.submit_response_snapshot,
        source.submitResponseSnapshot,
        source.material_status,
        source.materialStatus,
      ];

      return details.some((value) => this.detailNeedsSupplement(value));
    },
    detailNeedsSupplement(value) {
      if (isEmptyValue(value)) return false;
      if (Array.isArray(value)) return value.some((item) => this.detailNeedsSupplement(item));
      if (!isPlainObject(value)) return statusNeedsSupplement(value);

      const reason = value.reject_reason || value.rejectReason || value.fail_reason || value.failReason || value.error;
      if (hasMeaningfulValue(reason)) return true;

      if (hasSupplementStatus(value, ["status", "state", "applyment_state", "material_state", "result"])) return true;

      const flags = [
        value.addition_required,
        value.additionRequired,
        value.supplement_required,
        value.supplementRequired,
        value.need_supplement,
        value.needSupplement,
      ];
      if (flags.some((item) => truthyFlag(item))) return true;

      return Object.keys(value).some((key) => this.detailNeedsSupplement(value[key]));
    },
    goFirstMissing() {
      const first = this.modules.find((item) => (this.missingByModule[item.key] || []).length);
      if (first) this.activeModule = first.key;
    },
    storeDictionariesWithFallback(...sources) {
      const dictionaries = clone(STORE_FALLBACK_DICTIONARIES);
      sources.filter(Boolean).forEach((source) => {
        const candidates = [
          source,
          source.dictionaries,
          source.dictionary,
          source.rules,
        ].filter(Boolean);
        candidates.forEach((item) => {
          STORE_DICTIONARY_KEYS.forEach((key) => {
            if (!isEmptyValue(item[key])) dictionaries[key] = clone(item[key]);
          });
        });
      });
      return dictionaries;
    },
    applyStoreDictionaries(source = {}) {
      this.dictionaries = this.storeDictionariesWithFallback(this.dictionaries, source);
    },
    applyMediaId(type, mediaId) {
      if (!mediaId) return;
      const map = {
        business_license_copy: ["subject", "license_copy"],
        certificate_copy: ["subject", "license_copy"],
        id_card_copy: ["subject", "id_card_copy"],
        id_card_national: ["subject", "id_card_national"],
        store_entrance_pic: ["business", "store_entrance_pic"],
        indoor_pic: ["business", "indoor_pic"],
        bank_card_copy: ["bank_account", "bank_card_media_id"],
      };
      const path = map[type];
      if (!path) return;
      this.$set(this.form[path[0]], path[1], mediaId);
    },
    upsertFile(file) {
      if (!file || !file.file_type) return;
      const nextFile = { ...file, file_type: this.canonicalFileType(file.file_type) };
      const filtered = this.files.filter((item) => {
        if (nextFile.id && item.id) return item.id !== nextFile.id;
        return this.canonicalFileType(item.file_type) !== nextFile.file_type;
      });
      this.files = [nextFile].concat(filtered);
    },
    canonicalFileType(type) {
      return FILE_TYPE_ALIASES[type] || type;
    },
    isRecognizable(type) {
      return RECOGNIZABLE_FILE_TYPES.indexOf(type) !== -1;
    },
    isMultipleFileType(type) {
      return !!MULTIPLE_FILE_LIMITS[type];
    },
    fileTypeLimit(type) {
      return MULTIPLE_FILE_LIMITS[type] || 1;
    },
    copyConfirmUrl() {
      if (!this.confirmUrl) return;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.confirmUrl);
      } else {
        const input = this.$refs.confirmInput && this.$refs.confirmInput.$el.querySelector("input");
        if (input) {
          input.select();
          document.execCommand("copy");
        }
      }
      eltips("确认链接已复制", "success");
    },
  },
};
</script>

<style lang="less" scoped>
.wechat-applyment-wizard {

  .wizard-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .head-actions {
    flex-shrink: 0;
  }

  .page-title {
    color: #303133;
    font-size: 18px;
    font-weight: 600;
  }

  .applyment-summary {
    display: grid;
    grid-template-columns: repeat(4, minmax(180px, 1fr));
    gap: 10px 16px;
    padding: 12px 14px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fff;
    color: #000;
    font-size: 13px;
  }

  .summary-item {
    min-width: 0;

    span {
      margin-right: 8px;
      color: #333;
    }
  }

  .wizard-body {
    min-height: 560px;
    padding: 16px;
  }

  .workspace-layout {
    display: flex;
    // align-items: flex-start;
  }

  .module-nav {
	  min-height: 600px;
    flex: 0 0 240px;
    margin-right: 16px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fff;
  }

  .module-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 44px;
    padding: 0 12px;
    border-bottom: 1px solid #f2f6fc;
    color: #000;
    font-size: 13px;
    cursor: pointer;

    &:last-child {
      border-bottom: none;
    }

    &.active {
      background: #ecf5ff;
      color: #006aff;
      font-weight: 600;
    }
  }

  .module-form {
    flex: 1;
    min-width: 0;
    padding: 0 10px;
  }

  .form-two-column {
    display: grid;
    grid-template-columns: minmax(520px, 680px) minmax(300px, 420px);
    grid-template-areas: "form material";
    gap: 24px;
    align-items: flex-start;

    &.document-first {
      grid-template-columns: minmax(300px, 420px) minmax(520px, 680px);
      grid-template-areas: "material form";
    }
  }

  .contact-single-column {
    max-width: 720px;
  }

  .form-main {
    grid-area: form;
    min-width: 0;
  }

  .material-side {
    grid-area: material;
    position: sticky;
    top: 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
    padding: 14px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fafcff;
  }

  .material-side-title {
    color: #303133;
    font-size: 14px;
    font-weight: 600;
  }

  .field-required {
    color: #ff4d4f;
    margin-left: 4px;
  }

  .material-side-desc {
    color: #000;
    font-size: 12px;
    line-height: 20px;
  }

  .form-main-title {
    margin-bottom: 16px;
    color: #000000;
    font-size: 14px;
    font-weight: 600;
  }

  .section-title {
    margin: 0 0 18px;
    padding-left: 8px;
    border-left: 3px solid #006aff;
    color: #303133;
    font-size: 15px;
    font-weight: 600;
    line-height: 18px;
  }

  .field-control {
    width: 520px;
    max-width: 100%;
  }

  .field-large {
    width: 520px;
    max-width: 100%;
  }

  .date-control {
    width: 180px;
  }

  .date-separator {
    display: inline-block;
    width: 28px;
    color: #000;
    text-align: center;
  }

  .ml10 {
    margin-left: 10px;
  }

  .mb15 {
    margin-bottom: 15px;
  }

  .confirm-box {
    text-align: left;
  }

  .confirm-qr {
    display: block;
    width: 220px;
    height: 220px;
    margin: 0 0 16px;
  }
}

@media (max-width: 1200px) {
  .wechat-applyment-wizard {
    .applyment-summary {
      grid-template-columns: repeat(2, minmax(180px, 1fr));
    }

    .workspace-layout {
      display: block;
    }

    .module-nav {
      display: grid;
      grid-template-columns: repeat(2, minmax(220px, 1fr));
      width: 100%;
      margin-right: 0;
      margin-bottom: 16px;
    }

    .module-item {
      border-right: 1px solid #f2f6fc;
    }

    .form-two-column,
    .form-two-column.document-first {
      display: flex;
      flex-direction: column;
    }

    .material-side {
      order: -1;
      position: static;
      margin-top: 8px;
    }
  }
}
.set_bg{
	background-color: #fafcff;
	border: 1px solid #ebeef5;
	    border-radius: 4px;
		display: inline-block;
		padding: 12px;
}
</style>
